import { PerformanceMonitoringVO } from "../vo/PerformanceMonitoringVO";
import { getLogger } from "@goodgamestudios/logger";

import DisplayObject = createjs.DisplayObject;
import Ticker = createjs.Ticker;

const logger = getLogger("CoreJS.PerformanceMonitoring.Proxy")


export const isCurrentFrameRateBelowTargetFramerate = (threshold: number = 5): boolean => Ticker.getMeasuredFPS() < (Ticker.framerate - threshold);
const avarage = (values: number[]) => values.reduce((tot, current) => tot + current) / values.length;


export class PerformanceMonitoringProxy {


    /**
     * Store the FPS values collected during the current set of measurements.
     * This array is cleared after the cooldown period in order to always have fresh values.
     */
    private readonly measuredFpsList: number[] = [];
    public maxFps: number;
    private _loginPausedTimeInMs: number = 0;
    // time in millisecond
    // -1 default value, used for check.
    private _loginPauseStartTimeInMS: number = -1;


    /**
     * measure memory usage, fps and maxFps
     */
    public measure(): void {
        this.maxFps = Ticker.framerate;
        let fps = Ticker.getMeasuredFPS();
        logger.debug("PerformanceMonitoringProxy::measure @ ", new Date(), fps);
        this.measuredFpsList.push(fps);
    }

    /**
     * creates a PerformanceMonitoringVO and fills it with average data
     */
    public get averageMeasurementResults(): PerformanceMonitoringVO {
        let performanceMonitoringVO: PerformanceMonitoringVO = new PerformanceMonitoringVO();
        performanceMonitoringVO.averageFPS = this.averageFps;
        // performanceMonitoringVO.loginTimeMs = this.loginTime;
        // performanceMonitoringVO.loginTime = performanceMonitoringVO.loginTimeMs / 1000;
        performanceMonitoringVO.maxFps = this.maxFps;
        logger.debug("PerformanceMonitoringProxy::averageMeasurementResults ", performanceMonitoringVO);
        return performanceMonitoringVO;
    }

    public resetMeasurements(): void {
        while (this.measuredFpsList.length > 0) {
            this.measuredFpsList.pop();
        }
    }

    //###############################################################################################

    /**
     * Gets the avarage FPS from our monitoring system
     * @returns {number}
     */
    public get averageFps(): number {
        let fps = this.measuredFpsList.length > 0 ? avarage(this.measuredFpsList) : Ticker.getMeasuredFPS();
        fps = Math.round(fps);
        logger.debug(`current target framerate ${Ticker.framerate} -   current avarage framerate ${fps}  }`);
        return fps;
    }


    /**
     *   checks if AVARAGE of Measured FPS  is below the expected FPS target
     *   DO NOT use it inside enter frames or loops since it loops the fps measurments and calculates the avarage every time!
     *  use isCurrentFrameRateBelowTargetFramerate  instead
     * @param threshold
     * @returns {boolean}
     */
    public isAvarageFrameRateBelowTargetFramerate(threshold: number = 5): boolean {
        return this.averageFps < (Ticker.framerate - threshold);
    }


    /**
     *  time in milliseconds
     */
    public get loginTime(): number {
        logger.debug("until logic and requirements of loginTime is understood i am returning milliseconds elapsed since first initialization of game")
        return Ticker.getTime()
        //  what do we mean with login time?  time elapsed since the user logged in.  time the user actually spent playing the game (so pause when in other browser tabs)  or what?
        //  TODO HTML5 this entire thing does not really make sense to me  (it always gives the UTC milliseconds because loginpauseStartTime is always -1..
        // if for anny reason the loginTime is asked when application is in background
        // the current time used is the one when the application was paused.
        // other wise it's the current time
        // let timer: number = this._loginPauseStartTimeInMS >= 0 ? this._loginPauseStartTimeInMS : Date.now();
        // return timer - this._loginPausedTimeInMs;
    }

    public pauseLoginTimeCounter(): void {
        // keep track when the application was paused
        // if _loginPauseStartTime >= 0 the application is already in pause
        // thus the right time when the application was paused is the first one.
        if (this._loginPauseStartTimeInMS < 0) {
            this._loginPauseStartTimeInMS = Date.now();
        }
    }

    public resumeLoginTimeCounter(): void {
        // if the _loginPauseStartTime < 0 the application is not in pause
        // thus if for any reason this function is called several time in a row the time is not update
        if (this._loginPauseStartTimeInMS >= 0) {
            this._loginPausedTimeInMs += (Date.now() - this._loginPauseStartTimeInMS);
            // reset the variable, this value is used for test thus do not change it.
            this._loginPauseStartTimeInMS = -1;
        }
    }
}
